import React, { useState, useEffect } from 'react';

import validate from '@vlabs/shared/validators';
import { Control } from '@vlabs/uikit';
import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { CustomFilterPopover } from '../components/CustomFilterPopover';
import { hasAnyError } from '../helpers';
import { useFilterCount } from '../hooks';
import st from '../shared.module.sass';

export const SimilarityInputsPopover = ({ onCountChange, ...props }) => {
  const { register, formState: { errors }, setValue } = useFormContext();
  const { t } = useTranslation();
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    setHasError(hasAnyError(errors, ['top_similar_object_similarity__gte', 'top_similar_object_similarity__lt']));
  }, [errors, errors.top_similar_object_similarity__gte,
    errors.top_similar_object_similarity__lt]);

  const [gte, lt] = useWatch({ name: ['top_similar_object_similarity__gte', 'top_similar_object_similarity__lt'] });
  const filterCount = [gte, lt].filter(Boolean).length > 0 ? 1 : 0;
  useFilterCount('similarity', filterCount, onCountChange);

  return (
    <CustomFilterPopover
      hasError={hasError}
      hasFilterValue={Boolean(filterCount)}
      testId="similarityFilter"
      triggerValue={t('similarity')}
      {...props}
    >
      <label className="Input__Label">{t('similarity %')}</label>
      <div className={st.flex}>
        <div className={st.DoubleInputs}>
          <Control.Input
            id="top_similar_object_similarity__gte"
            placeholder={t('от')}
            {...register('top_similar_object_similarity__gte', {
              min: validate.gte(0),
              max: validate.lte(100),
              validate: validate.number(),
            })}
            errors={errors}
            isClearable
            onClear={() => setValue('top_similar_object_similarity__gte', '')}
          />
        </div>
        <div className={st.DoubleInputs__Divider}>:</div>
        <div className={st.DoubleInputs}>
          <Control.Input
            id="top_similar_object_similarity__lt"
            placeholder={t('до')}
            {...register('top_similar_object_similarity__lt', {
              min: validate.gte(Math.max(gte, 0)),
              max: validate.lte(100),
              validate: validate.number(),
            })}
            errors={errors}
            isClearable
            onClear={() => setValue('top_similar_object_similarity__lt', '')}
          />
        </div>
      </div>
    </CustomFilterPopover>
  );
};
